<template>
  <div class="">
    <div
      class="h-48 rounded border border-dashed relative flex items-center justify-center p-5 cursor-pointer hover:text-gray-300"
      @mouseenter="dragOver"
      @mouseover="dragOver"
      @mouseleave="dragLeave"
      @dragover="dragOver"
      @dragleave="dragLeave"
      @mouseout="dragLeave"
    >
      <div class="flex-grow text-center text-sm">
        <div v-html="contextualText"></div>
      </div>
      <drag-overlay :dragging="dragging"></drag-overlay>
      <input
        class="absolute top-0 right-0 bottom-0 left-0 w-full h-full opacity-0 cursor-pointer"
        type="file"
        :accept="project.extension"
        multiple
        @change="onFileChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["i18n", "project"],
  mixins: [],
  data: function () {
    return {
      dragging: false,
    };
  },
  methods: {
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      Array.from(files).forEach((file) => {
        this.$store.dispatch("tuspload/startAttempt", {
          initial_project_id: this.project.id,
          user_id: this.$store.state.account.id,
          file,
          validationEndpoint: this.endpoint,
        });
      });
    },

    dragOver() {
      this.dragging = true;
    },

    dragLeave() {
      this.dragging = false;
    },
  },
  computed: {
    endpoint() {
      let endpoint = this.$store.state.dashboard.projects.routes.validate.replace(
        ":id",
        this.project.id
      );
      if (this.$route.query.exp_endpoint) {
        endpoint += "?exp_endpoint=1";
      }
      return endpoint;
    },

    nameOrExtension() {
      return this.project.hasFilename
        ? this.project.filename
        : "." + this.project.extension;
    },

    contextualText() {
      return this.project.hasFilename
        ? this.i18n.file.replace(":file", "<b>" + this.nameOrExtension + "</b>")
        : this.i18n.extension.replace(
            ":extension",
            "<b>" + this.nameOrExtension + "</b>"
          );
    },
  },
};
</script>
